/* eslint-disable */
import React, { Component } from 'react'
// import PropTypes from 'prop-types';
import { View, Text, TouchableOpacity, Image, Dimensions ,SafeAreaView, Platform } from 'react-native'
import styles from './Styles/OverLayPostViewStyle'
import { Button } from 'native-base';
import { Images, Fonts } from '../Themes'
import TextComponent from './TextComponent';
import AvatarComponent from './AvatarComponent';
import { NavigationActions } from 'react-navigation';
import NotificationManager from '../Lib/NotificationManager'
import I18n from "i18n-js"
import PostWallBase from '../Containers/PostWallBase'

import AuthActions from '../Redux/AuthRedux'
import { connect } from 'react-redux'

import API from '../Services/Api'

const screenWidth = Dimensions.get('window').width
const postbutton = screenWidth / 5 + 20
const width = (screenWidth - postbutton) / 4 // total button width, not icon width in case of non square buttons
/*export default */ class OverLayPostView extends Component {

  constructor(args) {
    super(args)
    console.log(`OverLayPostView constructor`)
    const transparent = this.props.transparent
    this.heightForWeb = 100 // see also in  *Style.js this is the background bar height 
    this.iconSizeForWeb = 60
    this.marginBottomForWeb = 10
    
    this.iconViewWithBottomGapStyle = [styles.iconView, {marginBottom: 15, height: this.heightForWeb}] // convert style?  Object.assign?
    this.styleUnreadMore10 = {
      /*top: -8, right: 5, */ borderRadius: 15, padding: 5,
      backgroundColor: 'red', position: 'absolute'
    }
    this.styleUnreadLess10 = {
      /*top: -3, right: 10,*/ borderRadius: 10,
      minWidth: 20, minHeight: 20, maxWidth: 20, maxHeight: 20,
      alignItems: 'center', justifyContent: 'center',
      backgroundColor: 'red', position: 'absolute'
    }
    this.panelBackgroundStyle = transparent ?
      null :
      { 
        position: 'absolute',
        top: 13,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.80)'
      }
    this.newPostStyle = { 
      position: 'absolute', 
      left: (screenWidth - (postbutton - 15)) / 2,
      bottom: 18,
    }
    this.buttonGapStyle = {width: postbutton, height: 10}
    this.hitSlop = {left: 10, right: 10, top: 10, bottom: 10}
    this.hitSlopLarge = {left: 15, right: 15, top: 15, bottom: 15}
    this.avatarStyle = { borderColor: '#FFFFFF', marginBottom: 10 }
    this.avatarSize = postbutton * 0.45
    this.postButtonTextContainerStyle = {position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, justifyContent: 'center', alignItems: 'center'}
    this.postButtonTextStyle = {fontFamily : Fonts.style.font.bold, fontSize: 12, width: postbutton * .50, textAlign: 'center'}
    this.postButtonLabel = I18n.t("editpost.postUC")
    this.unreadMessageCountStyle = {color: 'white'}
    this.walletImage = transparent ? Images.newWalletWhite : Images.newWallet
    this.messageImage = transparent ? Images.messageWallOffTeleWhite : Images.messageWallOffTele
    this.exploraImage = transparent ? Images.exploraIconWhite : Images.exploraIcon
    this.authUserId = this.props.auth.user.UserId

    this.api = API.create() // for logout web 
  }

  changeRoute = (routeName) => this.props.navigation.navigate(routeName, {})
  
  resetRoute = (routeName, params = {}) => {
    this.props.navigation.dispatch(NavigationActions.reset({
        index: 0,
        key: null,
        actions: [NavigationActions.navigate({ routeName: routeName, params: params })]
    }))
  }

  avatarClick = () => {  
    const navigation = this.props.navigation
    let firstItem = null
    if (this.props.parentState && this.props.parentState.dataProvider) {
      const data =  this.props.parentState.dataProvider._data
      if (data && data.length > 0) {
          console.log("firstItem before nav to profile = " + JSON.stringify(data[0]))
          // firstItem = data[0] // default just use most recent post on main wall
          const foundPost = data.find(post => post.UserId == this.authUserId)
          if (foundPost)
            firstItem = foundPost // otherwise just use most recent ipost
          console.log(`firstItem for userid: ${this.authUserId} profile = ` + JSON.stringify(firstItem))
      }
    }
    navigation.navigate('profile', { userId: this.authUserId, firstItem })
  }

  changeRouteKargoelytics = () => {
    this.changeRoute('kargoelytics')
  }

  changeRouteMessages = () => {
    this.changeRoute('messages')
  }

  onExploraPress = ( ) => {
    // this.resetRoute('explora') // no anim yet
    this.props.navigation.navigate('explora') // to allow for anim but stacking up
  }

  onNewPost = () => {
    this.props.onNewPost()
  }

  // temp for web copied from settings screen
  logout = () => {
    setTimeout(() => {
      this.api.cacheDeleteAll() // selective cache
      //I18n.locale = getDeviceLanguage()
      PostWallBase.clearDataCache() // xhr stuff / wall
      this.api.clearCache() // main offline api cache
    }, 10)
    if (this.props.logout)
      this.props.logout()
  }

  getAlertTimeStamps = (user) => {
    if (!user)
      return []
    const list = [
        user.SellerOrderLastTimeStamp
      , user.EndorserOrderLastTimeStamp
      , user.PurchaserOrderLastTimeStamp
      , user.CouponLastTimeStamp
      ]
    return list.filter( ts => typeof ts != 'undefined' && ts != null && Number(ts) > 0 )
  }

  shouldComponentUpdate(nextProps, nextState) {
    // console.log(`OverLayPostView render shouldComponentUpdate`)
    // avatar updates by itself
    if (this.props.unreadMessages != nextProps.unreadMessages)
      return true
    if ((this.getAlertTimeStamps(this.props.user) > 0) != (this.getAlertTimeStamps(nextProps.user) > 0))
      return true
    return false
  }

  render() {
    // console.log(`OverLayPostView render`)
    NotificationManager.postNotification("PostWallBase_render")
    const { onNewPost, auth, navigation , unreadMessages = 0, transparent = true, onLongPressAvatar } = this.props
    const absoluteNumberStr = String(Math.abs(Number(unreadMessages)))
/*
    let alertTimeStamps = this.props.user
                        ? [ this.props.user.SellerOrderLastTimeStamp
                          , this.props.user.EndorserOrderLastTimeStamp
                          , this.props.user.PurchaserOrderLastTimeStamp
                          , this.props.user.CouponLastTimeStamp
                          ]
                        : false
      , enabledAlertTimeStamps = alertTimeStamps? alertTimeStamps.filter( ts => typeof ts != 'undefined' && ts != null && Number(ts) > 0 ) : [ ]
      , kargoelyticsAlertEnabled = enabledAlertTimeStamps.length > 0
*/
    const kargoelyticsAlertEnabled = this.getAlertTimeStamps(this.props.user) > 0
    // avatarView
    
    const isWeb = Platform.OS == 'web'

    let msgDotRight = width / 2 - this.iconSizeForWeb/2 
    return (
      <View pointerEvents="box-none" style={[styles.container, {height: this.heightForWeb}]}>
        <View pointerEvents="box-none" style={[styles.container, {height: this.heightForWeb}]}>
          <View style={[this.panelBackgroundStyle, {height: this.heightForWeb}]}></View>
          <View style={[this.iconViewWithBottomGapStyle, {height: this.heightForWeb}]}>
           {auth.user && this.authUserId && <AvatarComponent
					    onLongPress={(x) => {if (!isWeb) onLongPressAvatar(x)}}
              onPress={(x) => {/*if (!isWeb) */ this.avatarClick(x)}}
              style={[this.avatarStyle, {width: this.iconSizeForWeb, height: this.iconSizeForWeb, marginBottom: 0}]}
              userId={this.authUserId}
              size={this.avatarSize} />
           }
          </View>
          <View style={styles.iconView}>
            {!isWeb && <TouchableOpacity onPress= {this.changeRouteKargoelytics}>
              <Image resizeMode={'contain'} style={[styles.icon, {width: this.iconSizeForWeb, height: this.iconSizeForWeb, marginBottom: this.marginBottomForWeb}]} source={this.walletImage} />
            </TouchableOpacity>}
            { (false && kargoelyticsAlertEnabled) &&
              <View style={this.styleUnreadLess10}></View>
            }
          </View>
          <View style={this.buttonGapStyle}></View>
          <View style={[styles.iconView, {height: this.heightForWeb}]}>
            {!isWeb && <TouchableOpacity  hitSlop={this.hitSlop} onPress= {this.changeRouteMessages}>
              <Image resizeMode={'contain'} style={[styles.icon, {width: this.iconSizeForWeb, height: this.iconSizeForWeb, marginBottom: this.marginBottomForWeb}]} source={this.messageImage} />
            </TouchableOpacity>}
            { (false && !!unreadMessages) &&
              <TextComponent numberOfLines={1} onPress={this.changeRouteMessages} hitSlop={this.hitSlopLarge}
                containerStyle={[unreadMessages < 10 ? this.styleUnreadLess10 : this.styleUnreadMore10]}
                style={this.unreadMessageCountStyle} text={absoluteNumberStr} />
            }
          </View>
          <View style={styles.iconView}>
            {<TouchableOpacity onPress={this.onExploraPress} hitSlop={this.hitSlop}>
              <Image resizeMode={'contain'} style={[styles.icon, {width: this.iconSizeForWeb, height: this.iconSizeForWeb, marginBottom: this.marginBottomForWeb}]} source={this.exploraImage}/>
            </TouchableOpacity>}
          </View>
        </View>

        <TouchableOpacity
          style={[this.newPostStyle, {height: this.iconSizeForWeb}]} activeOpacity={0.8}
          onPress={this.onNewPost}>
          <Image style={[styles.buttonPost, {height: this.iconSizeForWeb, width: this.iconSizeForWeb, left: (width - this.iconSizeForWeb)/2}]} source={Images.newPostButton} />
          <View style={[this.postButtonTextContainerStyle, {width: this.iconSizeForWeb, left: (width - this.iconSizeForWeb)/2}]}>
            <Text numberOfLines={1} adjustsFontSizeToFit style={[this.postButtonTextStyle, {width: this.iconSizeForWeb, fontFamily: 'sans-serif'}]}>{this.postButtonLabel}</Text>
          </View>
        </TouchableOpacity>
        
        {false &&
        <TouchableOpacity
          style={{position:' absolute', left: 10, bottom: 10, height: 20, width:60}} activeOpacity={0.5}
          onPress={this.logout}>
            <Text numberOfLines={1} adjustsFontSizeToFit style={{fontFamily: Fonts.style.font.regular}}>Logout</Text>
        </TouchableOpacity>}

      </View>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(AuthActions.logoutRequest()),
  }
}

export default connect(null, mapDispatchToProps)(OverLayPostView)
